<template>
  <div class="drag-column" v-if="isShowDrayg">
    <div class="dc-modal">
      <div class="dc-top">
        <div class="dct-top">
          <div class="dctt-select">
            {{ $lang('已选数据源') }}<span>({{ list1.length }})</span>
          </div>
          <div class="dctt-btn">
            <el-button size="mini" class="dcttb-btn" @click="hideModal" type="default">{{ $lang('关闭') }}</el-button>
            <el-button size="mini" class="dcttb-btn" :loading="keyBtn" @click="setCustomColumn" type="primary">{{ $lang('保存') }}</el-button>
          </div>
        </div>
        <div class="dct-drag" v-if="list1.length" ref="dragTop">
          <draggable :draggable="list1.length !== 1 ? '.dctd-list' : ''" @drop="drop" tag="div" v-model="list1" v-bind="dragOptions" @start="start" @end="end">
            <transition-group type="transition" name="flip-list">
              <div class="dctd-list" ref="topList" @click.stop="drop" v-for="element in list1" :key="element.name">
                <div class="dctdl-item animated" :class="element.isShow ? 'bounceInDownDefault bounceInDown' : ''">
                  <el-tooltip v-if="calcStrLen(element.column) > 14 && isShowToolTip" :content="$lang(element.column)" placement="top">
                    <div class="dctdli-text">{{ $lang(element.column) }}</div>
                  </el-tooltip>
                  <template v-else>
                    <div class="dctdli-text">{{ $lang(element.column) }}</div>
                  </template>
                  <div class="dctdli-x" @click="delcolumn(element.name, $event)">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
        <div class="dct-drag" v-else>
          <div class="dctd-modal"><img class="dctd-img" src="../../../assets/images/uploading.gif" alt="" /></div>
        </div>
      </div>

      <div class="dc-bottom" ref="bottomBox">
        <div class="dct-top">
          <div class="dctt-tip">{{ $lang('选择数据源（可向上拖动数据参数）') }}</div>
          <div class="dctt-right">
            <div class="dctt-all" @click="setAllColumn">{{ $lang('应用全部') }}</div>
            <div class="dctt-default" @click="setReset">{{ $lang('恢复默认') }}</div>
            <el-input class="dcb-input" :disabled="disabled" clearable @input="inputPurchaseCount" :placeholder="$lang('搜索数据源')" v-model="searchInput">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
        </div>
        <div class="dct-drag" v-if="list2.length">
          <draggable
            tag="div"
            :draggable="isShowToolTip ? '.dctd-list' : ''"
            :class="isSetAll ? 'animated bounceInUp' : ''"
            @start="start"
            @end="end"
            v-bind="dragOptions"
            :list="list2"
            :sort="false"
          >
            <transition-group type="transition" name="flip-list">
              <div class="dctd-list" @click="moveToTop(element.name, $event)" v-for="element in list2" :key="element.name">
                <div class="dctdl-item animated2" :class="element.isShow ? 'bounceInDownDefault bounceInDown' : ''">
                  <el-tooltip v-if="calcStrLen(element.column) > 14 && isShowToolTip" :content="$lang(element.column)" placement="top">
                    <div class="dctdli-text">{{ $lang(element.column) }}</div>
                  </el-tooltip>
                  <template v-else>
                    <div class="dctdli-text">{{ $lang(element.column) }}</div>
                  </template>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
        <div class="dct-drag" v-else>
          <div class="dcd-null" v-if="isSearch">{{ $lang('暂无数据') }}</div>
          <div class="dcd-null" v-else>{{ $lang('数据源已用完') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import fetch from '@http/request'
import { RESPONSE_SUCCESS } from '@constants'
import qs from 'qs'
export default {
  name: 'DragColumn',
  props: {
    dynamicColumns: {
      type: Array,
      required: true,
      default: () => {
        return []
      },
    },
    defaultUrl: {
      type: String,
      default: () => {
        return '/vip/column/getDefaultColumn'
      },
    },
  },
  components: {
    draggable,
  },
  data() {
    return {
      list1: [],
      list2: [],
      isShowDrayg: false,
      searchInput: '',
      isShow: true,
      currentList2: [],
      keyBtn: false,
      isSetAll: false,
      isSearch: true,
      disabled: false,
      isClicked: false,
      isShowToolTip: true,
    }
  },
  created() {
    // for (const item of this.dynamicColumns) {
    //   if (item.show) {
    //     this.list1.push(item);
    //   } else {
    //     this.list2.push(item);
    //   }
    // }
    // this.currentList2 = this.list2;
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: 'people',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
  },
  watch: {},
  methods: {
    calcStrLen(str) {
      return str.replace(/[\u0391-\uFFE5]/g, 'aa').length
    },
    addDrag() {
      setTimeout(() => {
        this.isShowToolTip = false
      }, 100)
    },
    drop(e) {
      setTimeout(() => {
        this.isShowToolTip = true
      }, 100)
      if (this.list1.length === 1) return
      e.stop
    },
    start() {
      console.log(' @start="start" @end="end"')
      this.isDragging = true
      this.isShowToolTip = false
    },
    end() {
      console.log(' @start="start" @end="end"')
      this.isDragging = false
      setTimeout(() => {
        this.isShowToolTip = true
      }, 100)
    },
    openDialog() {
      this.isShowDrayg = true
      this.list1 = []
      this.list2 = []
      this.searchInput = ''
      for (const item of this.dynamicColumns) {
        if (item.show) {
          this.list1.push(item)
        } else {
          this.list2.push(item)
        }
      }
      this.currentList2 = this.list2
    },
    // 关闭弹窗
    hideModal() {
      this.isShowDrayg = false
    },
    // 点击到已选数据源
    moveToTop(name, event) {
      const { x, y } = event
      if (this.isClicked) return
      this.isClicked = true
      const { offsetLeft, offsetTop } = this.$refs.topList[this.$refs.topList.length - 1]
      for (const [index, item] of this.list2.entries()) {
        if (item.name === name) {
          const curentIndex = index + 1
          item.isShow = true
          let leftW = parseInt(offsetLeft) - x + 400
          let topH = parseInt(offsetTop) - y + 180
          const len = this.list1.length + 1
          if (curentIndex % 6 === 0 && (len % 6 === 0 || (len - 1) % 6 === 0)) {
            leftW = 0
          }
          if (curentIndex === parseInt(curentIndex / 6) * 6 + 1) {
            leftW = leftW > 0 ? leftW : -leftW
          }
          if (topH > 0) topH = -topH
          this.runkeyframesFn2(leftW, topH)
          this.$set(this.list2, index, item)
        }
      }
      setTimeout(() => {
        this.isClicked = false
        for (const [index, item] of this.list2.entries()) {
          if (item.name === name) {
            item.isShow = false
            this.list1.push(item)
            this.list2.splice(index, 1)
          }
        }
        // const obj = this.list2.find(item => item.name === name);
        // if (obj) obj.isShow = false;
        // this.list2 = this.list2.filter(item => item.name !== name);
        // this.list1.push(obj);
        setTimeout(() => {
          this.$refs.dragTop.scrollTop = 100000
        }, 0)
        if (!this.list2.length) {
          this.disabled = false
          this.isSearch = false
        }
      }, 300)
    },
    // 动态插入样式
    runkeyframesFn(leftW, topH) {
      const runkeyframes = ` @keyframes bounceInDown{
        to {
          -webkit-animation-timing-function: cubic-bezier(0.1, 0.2, 0.3, 0.5);
          animation-timing-function: cubic-bezier(0.1, 0.2, 0.3, 0.5);
          opacity: 1;
        }
        to {
          -webkit-transform: translate(${leftW}px, ${topH}px);
          transform: translate(${leftW}px, ${topH}px);
        }
      }`
      // 创建style标签
      const style = document.createElement('style')
      // 设置style属性
      style.type = 'text/css'
      // 将 keyframes样式写入style内
      style.innerHTML = runkeyframes
      // 将style样式存放到head标签
      document.getElementsByTagName('head')[0].appendChild(style)
    },
    runkeyframesFn2(leftW, topH) {
      const runkeyframes = ` @keyframes bounceInDown{
        to {
          -webkit-animation-timing-function: cubic-bezier(0.1, 0.2, 0.3, 0.4, 0.5);
          animation-timing-function: cubic-bezier(0.1, 0.2, 0.3, 0.4, 0.5);
          opacity: 1;
        }
        to {
          -webkit-transform: translate(${leftW}px, ${topH}px);
          transform: translate(${leftW}px, ${topH}px);
          opacity: 0;
        }
      }`
      // 创建style标签
      const style = document.createElement('style')
      // 设置style属性
      style.type = 'text/css'
      // 将 keyframes样式写入style内
      style.innerHTML = runkeyframes
      // 将style样式存放到head标签
      document.getElementsByTagName('head')[0].appendChild(style)
    },
    getOffset(el) {
      el = el.getBoundingClientRect()
      return {
        offsetLeft: el.left + window.scrollX,
        offsetTop: el.top + window.scrollY,
      }
    },
    // 删除选中的
    delcolumn(name, event) {
      if (this.list1.length === 1) {
        return this.$message({
          type: 'error',
          message: this.$lang('最少保留一条已选数据'),
        })
      }
      const { x, y } = event
      // console.log("this.$refs.bottomBox", this.$refs.top);
      const { offsetLeft, offsetTop } = this.getOffset(this.$refs.bottomBox)
      for (const [index, item] of this.list1.entries()) {
        if (item.name === name) {
          item.isShow = true
          const leftW = parseInt(offsetLeft) - x + 171
          const topH = parseInt(offsetTop) - y + 60
          this.runkeyframesFn(leftW, topH)
          this.$set(this.list1, index, item)
        }
      }
      setTimeout(() => {
        const obj = this.list1.find((item) => item.name === name)
        if (obj) obj.isShow = false
        this.list1 = this.list1.filter((item) => item.name !== name)
        this.list2.unshift(obj)
        this.disabled = false
      }, 300)
    },
    // 请求接口数据
    setCustomColumn() {
      this.keyBtn = true
      this.list2 = this.currentList2.filter((item) => !this.list1.includes(item))
      this.list1.map((item) => (item.show = true))
      this.list2.map((item) => (item.show = false))
      const columnList = [...this.list1, ...this.list2]
      this.$parent
        .setCustomColumn({ columnList })
        .then((res) => {
          this.keyBtn = false
          this.hideModal()
        })
        .catch((data) => {
          this.keyBtn = false
          this.hideModal()
        })
    },
    // 应用全部
    setAllColumn() {
      this.isSetAll = true
      this.isSearch = false
      setTimeout(() => {
        this.isSetAll = false
        this.list1 = [...this.list1, ...this.list2]
        if (this.searchInput) {
          this.list2 = this.currentList2.filter((item) => !this.list2.includes(item))
          this.currentList2 = this.list2
        } else {
          this.list2 = []
          this.currentList2 = []
        }
        this.searchInput = ''
        if (!this.list2.length) this.disabled = true
      }, 100)
    },
    // 恢复默认
    async setReset() {
      const msgcode = this.$parent.tableOption.dynamicOptions.params.tableName
      this.list1 = []
      this.list2 = []
      this.disabled = false
      const { code, data, msg } = await fetch.get(this.defaultUrl + `?` + qs.stringify({ tableName: msgcode }))
      if (code === RESPONSE_SUCCESS) {
        this.searchInput = ''
        for (const item of data) {
          if (item.show) {
            this.list1.push(item)
          } else {
            this.list2.push(item)
          }
        }
        this.currentList2 = this.list2
      } else {
        this.$message({ type: 'error', message: msg })
      }
    },
    inputPurchaseCount() {
      this.isSearch = true
      if (this.searchInput) {
        const list = []
        console.log('currentList2', this.currentList2)
        for (const item of this.currentList2) {
          if (this.$lang(item.column).includes(this.searchInput)) list.push(item)
        }
        this.list2 = list
      } else {
        this.list2 = this.currentList2
      }
    },
  },
}
document.body.ondrop = function (event) {
  event.preventDefault()
  event.stopPropagation()
}
</script>
<style lang="scss" scoped>
.bounceInDownDefault {
  // position: fixed !important;
  z-index: 999999;
  background: none !important;
}
@-webkit-keyframes bounceInUp {
  to {
    -webkit-animation-timing-function: cubic-bezier(0.1, 0.2, 0.3, 0.5);
    animation-timing-function: cubic-bezier(0.1, 0.2, 0.3, 0.5);
  }

  to {
    -webkit-transform: translate3d(0, -100px, 0);
    transform: translate3d(0, -100px, 0);
  }
}

.bounceInUp {
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
}
.bounceInDown {
  -webkit-animation-name: bounceInDown;
  animation-name: bounceInDown;
}
.animated {
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated2 {
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
@media (print), (prefers-reduced-motion: reduce) {
  .animated {
    -webkit-animation-duration: 0.5s !important;
    animation-duration: 0.5s !important;
    -webkit-transition-duration: 0.5s !important;
    transition-duration: 0.5s !important;
    -webkit-animation-iteration-count: 1 !important;
    animation-iteration-count: 1 !important;
  }
}

.drag-column {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  .flip-list-move {
    transition: transform 0.3s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    .dctdl-item {
      .dctdli-x {
        display: none;
      }
    }
  }
  .dc-modal {
    width: 1000px;
    position: relative;
    .dc-top {
      width: 100%;
      // height: 210px;
      background: #fff;
      border-radius: 4px;
      .dct-top {
        display: flex;
        align-items: center;
        height: 54px;
        padding: 0 20px;
        width: 100%;
        box-sizing: border-box;
        border-bottom: 1px solid #dddddd;
        justify-content: space-between;
        .dctt-select {
          font-size: 14px;
          color: #333;
          font-weight: bolder;
          span {
            font-weight: 500;
            font-size: 12px;
            margin-left: 3px;
          }
        }
        .dcttb-btn {
          box-sizing: border-box;
          height: 28px;
          text-align: center;
          line-height: 28px;
          padding: 0 20px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
      .dct-drag {
        height: 156px;
        position: relative;
        overflow: auto;
        padding: 0 0 0 40px;
        box-sizing: border-box;
        .dctd-modal {
          position: absolute;
          z-index: 1;
          left: 0;
          top: 0;
          width: 100%;
          height: 156px;
          // background: rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          .dctd-img {
            width: 200px;
            height: 200px;
          }
        }
        span {
          width: 100%;
          // height: 156px;
          padding: 20px 0 10px 0;
          box-sizing: border-box;
          display: block;
          position: relative;
        }
        .dctd-list {
          width: 152px;
          display: inline-block;
          margin-bottom: 10px;
          &:nth-of-type(6n) {
            width: 144px;
          }
          .dctdl-item {
            width: 144px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            box-sizing: border-box;
            cursor: move;
            font-size: 12px;
            border-radius: 4px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            .dctdli-text {
              max-width: 94px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .dctdli-x {
              position: absolute;
              display: none;
              line-height: 1;
              padding: 9px 10px 10px;
              top: 0;
              right: 0;
              box-sizing: border-box;
              cursor: pointer;
              .el-icon-close {
                font-size: 14px;
              }
            }
            &:hover {
              // background: rgba(221, 221, 221, 0.1);
              // border: 1px solid rgba(221, 221, 221, 0.5);
              // color: #999999;
              .dctdli-x {
                display: block;
              }
            }
          }
          i {
            cursor: pointer;
          }
          &:nth-of-type(6n) {
            margin-right: 0;
          }
        }
      }
    }
    .dc-bottom {
      margin-top: 10px;
      width: 100%;
      // height: 420px;
      background: #fff;
      border-radius: 4px;
      .dct-top {
        display: flex;
        align-items: center;
        height: 52px;
        padding: 0 20px;
        box-sizing: border-box;
        justify-content: space-between;
        border-bottom: 1px solid #dddddd;
        .dctt-right {
          display: flex;
        }
        .dcb-input {
          width: 200px;
        }
        .dctt-tip {
          font-size: 14px;
          color: #333;
          font-weight: bolder;
        }
        .dctt-all {
          font-size: 12px;
          padding: 10px 18px 10px 18px;
          // margin-left: 350px;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
        .dctt-default {
          font-size: 12px;
          padding: 10px 36px 10px 18px;
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
      }
      .dct-drag {
        overflow: auto;
        padding: 0 0 0 40px;
        overflow: auto;
        box-sizing: border-box;
        height: 365px;
        span {
          width: 100%;
          padding: 20px 0 10px 0;
          box-sizing: border-box;
          display: block;
        }
        .dcd-null {
          height: 365px;
          width: 100%;
          color: #999999;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .dctd-list {
          width: 152px;
          display: inline-block;
          margin-bottom: 10px;
          &:nth-of-type(6n) {
            width: 144px;
          }
          .dctdl-item {
            width: 144px;
            height: 32px;
            color: #999999;
            background: rgba(221, 221, 221, 0.1);
            border: 1px solid rgba(221, 221, 221, 0.5);
            line-height: 32px;
            text-align: center;
            box-sizing: border-box;
            cursor: move;
            font-size: 12px;
            border-radius: 4px;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            .dctdli-text {
              max-width: 94px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            &:hover {
              background: transparent;
              .dctdli-x {
                display: none;
              }
            }
          }
          i {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
